import B from "./design-system.es58.js";
import { resolveComponent as o, openBlock as n, createElementBlock as r, normalizeClass as C, createBlock as d, withCtx as k, createVNode as N, createCommentVNode as i, createTextVNode as l, createElementVNode as h, renderSlot as s } from "vue";
/* empty css                    */
/* empty css                    */
import E from "./design-system.es128.js";
/* empty css                    */
/* empty css                    */
import T from "./design-system.es59.js";
/* empty css                    */
/* empty css                    */
import v from "./design-system.es37.js";
/* empty css                    */
const m = "info", p = "subtle", u = "warning", f = "critical", g = "good", $ = {
  name: "DsInlineAlert",
  components: { Icon: B, IconButton: T, DsBox: v },
  props: {
    /**
     * As boolean, shows default icon for given type. As string, renders custom icon
     */
    leadingIcon: {
      type: [Boolean, String],
      default: !1
    },
    /**
     * Indicates the level of severity of the alert
     * @values info, subtle, warning, critical, good
     */
    type: {
      type: String,
      default: "info",
      validator: (e) => [m, p, u, f, g].includes(e)
    }
  },
  computed: {
    leadingIconName() {
      if (typeof this.leadingIcon == "string")
        return this.leadingIcon;
      switch (this.type) {
        case m:
        case p:
          return "info-circle";
        case u:
          return "alert-triangle";
        case f:
          return "alert-octagon";
        case g:
          return "check-circle";
        default:
          return "info-circle";
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit("close");
    }
  }
}, D = { class: "inline-alert-message" }, P = {
  key: 0,
  class: "inline-alert-footer"
}, Y = {
  key: 1,
  class: "inline-alert-trailing"
};
function A(e, t, a, S, V, c) {
  const I = o("Icon"), _ = o("DsBox"), y = o("IconButton");
  return n(), r("div", {
    class: C(["inline-alert", a.type])
  }, [
    a.leadingIcon ? (n(), d(_, {
      key: 0,
      "padding-y": "spacing-150",
      "padding-left": "spacing-150"
    }, {
      default: k(() => [
        N(I, {
          name: c.leadingIconName,
          style: { "--icon-color": "var(--inline-alert-icon-color)" }
        }, null, 8, ["name"])
      ]),
      _: 1
    })) : i("", !0),
    t[1] || (t[1] = l()),
    h("span", D, [
      s(e.$slots, "default", {}, void 0, !0),
      t[0] || (t[0] = l()),
      e.$slots.footer ? (n(), r("div", P, [
        s(e.$slots, "footer", {}, void 0, !0)
      ])) : i("", !0)
    ]),
    t[2] || (t[2] = l()),
    e.$slots.trailing ? (n(), r("div", Y, [
      s(e.$slots, "trailing", {}, void 0, !0)
    ])) : e.$attrs.onClose ? (n(), d(y, {
      key: 2,
      class: "inline-alert-close-button",
      name: "x",
      onClick: c.handleClose
    }, null, 8, ["onClick"])) : i("", !0)
  ], 2);
}
const q = /* @__PURE__ */ E($, [["render", A], ["__scopeId", "data-v-b602a7d0"]]);
export {
  q as default
};
//# sourceMappingURL=design-system.es63.js.map
